export const locale = {
    lang: 'nl',
    data: {
        'HOME': {
            'HELLO': 'Welkom bij de intranet van Divardy',
            'Wat': 'Hieronder ziet u uw rooster betreft de diensten van de huidige week bij uw bedrijf.',
        },
    }
};

